/* eslint-disable @typescript-eslint/no-explicit-any */
import { EditOutlined } from '@ant-design/icons'
import { Button, Form, Modal, Select, Space, Tooltip } from 'antd'
import React, { useState } from 'react'
import { useTask } from '~/hooks/Tasks/useTask'
import { translate } from '~/utils/locale'

// import { Container } from './styles';

const ExecutionTask: React.FC = () => {
  const { task, updateCheckInTask, refetch } = useTask()
  const [status, setStatus] = useState('')

  const [isModalVisible, setIsModalVisible] = useState(false)

  async function CheckInTask() {
    const data = {
      status: {
        collaborator_id: task?.responsible.id,
        location: {
          x: task?.address.location.x,
          y: task?.address.location.y,
        },
      },
    }

    try {
      if (status === 'checkin') {
        await updateCheckInTask(data, 'check-in')
      }

      if (status === 'pause') {
        await updateCheckInTask(data, 'pause-task')
      }

      if (status === 'resumeWorking') {
        await updateCheckInTask(data, 'resume-working')
      }

      if (status === 'checkout') {
        await updateCheckInTask(data, 'checkout')
      }

      refetch()
      setIsModalVisible(false)
    } catch (err: any) {
      console.log(err)
    }
  }

  const showModal = () => {
    setIsModalVisible(true)
  }

  const closeModal = () => {
    setIsModalVisible(false)
  }

  return (
    <>
      <Tooltip title="Status da Tarefa">
        <Button onClick={showModal} type="primary" icon={<EditOutlined />}>
          Iniciar Tarefa
        </Button>
      </Tooltip>
      <Modal
        title="Alterar Status da Tarefa"
        open={isModalVisible}
        onOk={closeModal}
        onCancel={closeModal}
        footer={[
          <Space key="buttons">
            <Button key="back" onClick={closeModal}>
              {translate('TasksRegistrationTypeTasksAbout.closeButton')}
            </Button>
            <Button
              type="primary"
              key="update"
              htmlType="submit"
              form="btn_update_task_status"
            >
              {translate('TasksRegistrationTypeTasksAbout.saveButton')}
            </Button>
          </Space>,
        ]}
      >
        <Form
          layout="vertical"
          id="btn_update_task_status"
          onFinish={CheckInTask}
        >
          <Form.Item label="Status da Tarefa">
            <Select
              placeholder="Selecionar Status"
              style={{ width: '100%' }}
              onChange={(e) => setStatus(e)}
            >
              {task?.current_status === 'checkin' ||
              task?.current_status === 'en-route' ? (
                <Select.Option value="checkin">Iniciar Tarefa</Select.Option>
              ) : (
                ''
              )}

              {task?.current_status === 'pause' ||
              task?.current_status === 'working' ? (
                <Select.Option value="pause">Pausar Tarefa</Select.Option>
              ) : (
                ''
              )}

              {task?.current_status === 'break' ||
              task?.current_status === 'working' ? (
                <Select.Option value="resumeWorking">
                  Retomar Tarefa
                </Select.Option>
              ) : (
                ''
              )}
              <Select.Option value="checkout">Finalizar Tarefa</Select.Option>
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </>
  )
}

export default ExecutionTask
